import { useFilmDownloads } from './FilmDownloadContext'
import { downloadHasExpired } from './downloadHasExpired'

export function useIsFilmDownloaded({ slug }) {
  const { downloads } = useFilmDownloads()
  const download = downloads?.current[slug]?.download
  return download?.status === 'complete' && !downloadHasExpired(download)
}
